import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Container } from 'reactstrap';
import classNames from 'classnames';
import { Image } from '@bottomless/common/components';
import { QuizHeader } from './QuizHeader';
import { QuestionText } from './QuestionText';

const answers = [
  {
    name: 'Drip/Pourover',
    value: 'specificGrind:5eaa7fc066c17ce02128fa3d',
    otherAnswers: [{ key: 'grind', value: 'grind:Medium' }],
    icon: 'https://bottomless.imgix.net/assets/q4-drip-pourover-transparent.png',
    className: 'quiz-image-padding-q2',
    event: {
      specific_grind: 'Medium, Drip/Pour Over',
    },
    explanation: 'Drip / Pour Over',
  },
  {
    name: 'French Press',
    value: 'specificGrind:5eaa7fc066c17ce02128fa3c',
    otherAnswers: [{ key: 'grind', value: 'grind:Coarse' }],
    icon: 'https://bottomless.imgix.net/assets/q4-french-press-transparent.png',
    className: 'quiz-image-padding-q2',
    event: {
      specific_grind: 'Coarse, French Press',
    },
    explanation: 'French Press',
  },
  {
    name: 'Espresso',
    value: 'specificGrind:5eaa7fc066c17ce02128fa3e',
    otherAnswers: [{ key: 'grind', value: 'grind:Fine' }],
    icon: 'https://bottomless.imgix.net/assets/q4-espresso-transparent.png',
    className: 'quiz-image-padding-q2',
    event: {
      specific_grind: 'Fine, Espresso',
    },
    explanation: 'Espresso',
  },
  {
    name: 'Cold Brew',
    value: 'specificGrind:5eaa7fc066c17ce02128fa3b',
    otherAnswers: [{ key: 'grind', value: 'grind:Extra Coarse' }],
    icon: 'https://bottomless.imgix.net/assets/q4-cold-brew-transparent.png',
    className: 'quiz-image-padding-q2',
    event: {
      specific_grind: 'Extra Coarse, Cold Brew',
    },
    explanation: 'Cold Brew',
  },
];

export const Question4 = ({ index, total, displayIndex, displayTotal, onAnswer, answers: quizAnswers, isMobile }) => {
  return (
    <>
      <QuizHeader index={displayIndex} total={displayTotal} description="You're off to a good start." />
      <QuestionText
        index={index - 1}
        total={total - 1}
        title="Brew Method"
        subtitle="What is your favorite way to brew?"
      />
      <div className="answers">
        <Container className="mt-4 px-0">
          <Row className="justify-content-center quiz-answer-row">
            {answers.map((answer, i) => (
              <Col key={i} xs="12" sm="6" lg="3" className="quiz-answer-col">
                <Card
                  body
                  tag="button"
                  className={classNames(
                    'd-flex flex-md-row flex-column align-items-center justify-content-center w-100 answer',
                    {
                      'answer-selected': quizAnswers?.[index] === answer.value,
                    }
                  )}
                  onClick={() => onAnswer(answer)}
                >
                  {quizAnswers?.[index] === answer.value && <span className="quiz-answer-check">✓</span>}
                  <Image src={answer.icon} width={50} alt={`Answer - ${answer.name}`} useSrcset />
                  <p
                    className={classNames('mb-0', {
                      'ml-4': !isMobile,
                      'mt-2': isMobile,
                    })}
                  >
                    {answer.name}
                  </p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

Question4.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  displayIndex: PropTypes.number.isRequired,
  displayTotal: PropTypes.number.isRequired,
  onAnswer: PropTypes.func.isRequired,
  answers: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
};
